import React, { useMemo } from 'react';
import NewLifetimeSalesBreakDownService from '../NewLifetimeSalesBreakDownService';

const LifetimeSalesBreakDownServiceTransfer = (props: any) => {
  const { tabMapConfig, config, ...restProps } = props;
  const { by_tab, by_top10_metric } = props?.data;
  const segmentVal = useMemo(
    () => props?.data?.by_type,
    [props?.data?.by_type],
  );

  const newConfig = useMemo(() => {
    // 不同口径参数
    const currentConfig = tabMapConfig[by_tab] || {};
    const { isfund, metric, ...restConfig } = currentConfig;
    if (isfund) {
      restConfig.metric = [...metric, by_top10_metric];
      restConfig.extMetricMap = {
        [metric?.[0]]: by_top10_metric,
        [by_top10_metric]: metric?.[0],
      };
    }
    return { metric, ...config, ...restConfig };
  }, [tabMapConfig, by_tab, config, by_top10_metric]);

  return (
    <NewLifetimeSalesBreakDownService
      {...restProps}
      key={by_tab}
      config={newConfig}
      segmentVal={segmentVal}
    ></NewLifetimeSalesBreakDownService>
  );
};

export default LifetimeSalesBreakDownServiceTransfer;
